var _rect, _path, _path2, _rect2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIsBreakDownSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#FDF4E5",
    stroke: "#FFF6E5",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0C2.23858 0 0 2.23858 0 5C0 5.06697 0.00131648 5.13362 0.00392497 5.19995C0.108881 2.53122 2.30554 0.399902 5 0.399902C7.69446 0.399902 9.89112 2.53122 9.99607 5.19995C9.99868 5.13362 10 5.06697 10 5C10 2.23858 7.76142 0 5 0Z",
    fill: "#CACACA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 10C7.76142 10 10 7.76142 10 5C10 4.933 9.99868 4.86631 9.99607 4.79996C9.89107 7.46864 7.69443 9.59991 5 9.59991C2.30558 9.59991 0.108938 7.46865 0.00392959 4.79997C0.00131938 4.86632 1.39664e-06 4.93301 1.39079e-06 5C1.14938e-06 7.76142 2.23858 10 5 10Z",
    fill: "black"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#FDF4E5",
    stroke: "#FFF6E5",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0C2.23858 0 0 2.23858 0 5C0 5.06697 0.00131648 5.13362 0.00392497 5.19995C0.108881 2.53122 2.30554 0.399902 5 0.399902C7.69446 0.399902 9.89112 2.53122 9.99607 5.19995C9.99868 5.13362 10 5.06697 10 5C10 2.23858 7.76142 0 5 0Z",
    fill: "#CACACA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 10C7.76142 10 10 7.76142 10 5C10 4.933 9.99868 4.86631 9.99607 4.79996C9.89107 7.46864 7.69443 9.59991 5 9.59991C2.30558 9.59991 0.108938 7.46865 0.00392959 4.79997C0.00131938 4.86632 1.39664e-06 4.93301 1.39079e-06 5C1.14938e-06 7.76142 2.23858 10 5 10Z",
    fill: "black"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4288 1.74315C5.3855 1.66926 5.32306 1.60787 5.2478 1.56517C5.17253 1.52248 5.0871 1.5 5.00013 1.5C4.91315 1.5 4.82772 1.52248 4.75245 1.56517C4.67719 1.60787 4.61475 1.66926 4.57145 1.74315L1.57204 6.74279C1.37214 7.07619 1.61185 7.5 2.00072 7.5H7.9991C8.38797 7.5 8.62811 7.07576 8.42777 6.74279L5.4288 1.74315ZM4.99925 3.21472C4.94396 3.21475 4.8893 3.22613 4.83877 3.24811C4.78824 3.2701 4.74298 3.30221 4.70589 3.34238C4.6688 3.38255 4.64072 3.42989 4.62344 3.48134C4.60616 3.53279 4.60007 3.58721 4.60557 3.6411L4.75867 5.14395C4.76381 5.20299 4.79139 5.25799 4.83594 5.29807C4.88049 5.33814 4.93877 5.36038 4.99925 5.36038C5.05974 5.36038 5.11802 5.33814 5.16257 5.29807C5.20712 5.25799 5.23469 5.20299 5.23983 5.14395L5.39293 3.6411C5.39843 3.58721 5.39234 3.53279 5.37507 3.48134C5.35779 3.42989 5.3297 3.38255 5.29261 3.34238C5.25552 3.30221 5.21026 3.2701 5.15973 3.24811C5.10921 3.22613 5.05454 3.21475 4.99925 3.21472ZM5.00013 5.78589C4.88411 5.78589 4.77285 5.83104 4.69082 5.9114C4.60879 5.99177 4.5627 6.10076 4.5627 6.21442C4.5627 6.32807 4.60879 6.43707 4.69082 6.51743C4.77285 6.5978 4.88411 6.64294 5.00013 6.64294C5.11614 6.64294 5.2274 6.5978 5.30943 6.51743C5.39146 6.43707 5.43755 6.32807 5.43755 6.21442C5.43755 6.10076 5.39146 5.99177 5.30943 5.9114C5.2274 5.83104 5.11614 5.78589 5.00013 5.78589Z",
    fill: "#EE3124"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsBreakDownSmall);
export default __webpack_public_path__ + "static/media/is_break_down_small.87698d3683641b159ebe96897e3df4c1.svg";
export { ForwardRef as ReactComponent };